import { ProgressBar } from "primereact/progressbar";
import useThemeProvider from "providers/ThemeProvider";
const SurveyProgress = ({ value }) => {
  const { Theme } = useThemeProvider();

  return (
      <ProgressBar
          className="progress-bar p-progressbar p-progressbar-value"
          {...{
              value,
              showValue: false,
              style: {
                  //  fontSize: 10,
                  fontFamily: 'Roboto'
                  // height: 20
              }
          }}
      />
  );
};

export default SurveyProgress;
